export enum GridConnectionMethod {
  OVERHEAD = 'OVERHEAD',
  UNDERGROUND = 'UNDERGROUND',
  OVER_AND_UNDER = 'OVER_AND_UNDER',
}
export const gridConnectionMethodToLabel = {
  [GridConnectionMethod.OVERHEAD]: 'Overhead Line',
  [GridConnectionMethod.UNDERGROUND]: 'Underground Cable',
  [GridConnectionMethod.OVER_AND_UNDER]: 'Mixture of Over and Under',
};
